import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import "./assets/css/custom.scss"
import VueTypedJs from 'vue-typed-js'
import utilsMixin from "@/mixins/utils";
import trackingMixin from "@/mixins/tracking";
import VueMeta from "vue-meta";
import VueCalendly from 'vue-calendly';
import ClientsCarousel from './views/Clients-carousel.vue'
import ClientsGrid from './views/Clients-grid.vue'

import VueLogger from 'vuejs-logger';
const isProduction = process.env.NODE_ENV === 'production';

const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
};

Vue.component('app-clients-carousel', ClientsCarousel);
Vue.component('app-clients-grid', ClientsGrid);

Vue.use(VueLogger, options);

Vue.use(VueCalendly);
Vue.use(VueTypedJs)
Vue.use(BootstrapVue)
Vue.use(VueMeta);
Vue.mixin(utilsMixin);
Vue.mixin(trackingMixin);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
